module.exports = __webpack_public_path__ + "static/media/22 Combat Knee.597c1362.jpg";